import React from "react";

import Grid from "@material-ui/core/Grid";

import { useQuery } from "@apollo/client";

import diseasesQuery from "./diseases-query";

import { SERVER_URI } from "../../../constants";

interface Props {
  nodes?: any[];
  panelCollectionName: string;
  // panelId?: string;
  // panelName: String;
  panelDefinition: any;
}

function CropOverviewPanelContainer(props: Props) {
  const {
    nodes,
    panelCollectionName,
    // panelId,
    // panelName,
    panelDefinition,
  } = props;
  const n = nodes ? nodes.join(",") : undefined;

  const { data, error, loading } = useQuery(diseasesQuery, {
    variables: {
      panelCollectionName: panelCollectionName,
      panelName: panelDefinition?.template,
      tab: panelDefinition?.id,
      node: n,
    },
  });
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error.message);
    return <div>Error! {error.message}</div>;
  }
  // TODO disease.panelCollPageURL must be modified
  return (
    <Grid container spacing={1} justify="center" alignItems="center">
      {data.diseases.map((disease: any) => (
        <Grid
          key={disease.panelCollPageURL}
          item
          xs={6}
          md={2}
          container
          justify="center"
          alignItems="flex-start"
        >
          <a href={disease.panelCollPageURL} title={disease.htmlTooltip}>
            <figure>
              <img
                style={{ width: "130px" }}
                src={`${SERVER_URI}${disease.imageURL}`}
              />
              <figcaption>{disease.label}</figcaption>
            </figure>
          </a>
        </Grid>
      ))}
    </Grid>
  );
}

export default CropOverviewPanelContainer;
